import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Buildings18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path d='M9.5 6.75H13.5V5.25H9.5V6.75Z' fill='currentColor' />
    <path d='M13.5 9.75H9.5V8.25H13.5V9.75Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 6.25H6.75V2.5C6.75 1.81917 7.31917 1.25 8 1.25H15C15.6808 1.25 16.25 1.81917 16.25 2.5V16C16.25 16.4142 15.9142 16.75 15.5 16.75H2.5C2.08579 16.75 1.75 16.4142 1.75 16V7.5C1.75 6.81917 2.31917 6.25 3 6.25ZM8.25 15.25V2.75H14.75V15.25H12.25V13H10.75V15.25H8.25ZM6.75 7.75V15.25H3.25V7.75H6.75Z'
      fill='currentColor'
    />
  </Svg>
);

Buildings18.displayName = 'Buildings18';
export default Buildings18;
